import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-placeholder-forbidden',
  templateUrl: './placeholder-forbidden.component.html',
  styleUrls: ['./placeholder-forbidden.component.scss']
})
export class PlaceholderForbiddenComponent {

}
